import { NgModule, ErrorHandler, InjectionToken } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { SharedModule } from './shared';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SiteLayoutComponent } from './_layout/site-layout/site-layout.component';
import { SiteHeaderComponent } from './_layout/site-header/site-header.component';
import { SiteFooterComponent } from './_layout/site-footer/site-footer.component';
import { AppLayoutComponent } from './_layout/app-layout/app-layout.component';
import { AppHeaderComponent } from './_layout/app-header/app-header.component';
import { RegisterComponent } from './register/register.component';
import { SuiModule } from 'ng2-semantic-ui';
import { WgisMapComponent } from './wgis/wgis.map.component';
import { WgisService } from './wgis/wgis.service';
import { HomeComponent } from './home/home.component';
import { SearchComponent } from './search/search.component';
import { FaqsComponent } from './faqs/faqs.component';
import { HelpComponent} from './help/help.component';
import { AuthComponent } from './auth/auth.component';
import { Error404Component } from './error404/error404.component';
import { SavedExperienceComponent, SavedOstComponent, DownloadsComponent } from './downloaded/';
import { MapsComponent } from './maps/maps.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AuthService, WMAIApiService, ApiService, S3Service } from './core';
// import { LeafletModule } from '@asymmetrik/ngx-leaflet';
import { ConfirmModalComponent } from './core/templates/confirm-modal.component';
import { ConfirmFormModalComponent} from './core/templates/confirm-form-modal.component';
import { ProfileComponent } from './profile/profile.component';
import { httpInterceptorProviders } from './core/interceptors/';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { SettingsComponent } from './settings/settings.component';
import { UserComponent } from './user/user.component';
import { Angulartics2Module } from 'angulartics2';
import { ImageModalComponent } from './core/templates';
import { ContactComponent } from './contact/contact.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { TermsComponent } from './terms/terms.component';
import { CreditComponent } from './credit/credit.component';
import { AppstoreComponent } from './appstore/appstore.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { ActivateUserComponent } from './activateuser/activateuser.component';
import { AngularFireAuthModule} from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging'
import {fireEnvironment} from '../environments/environment';
import {AngularFireModule} from '@angular/fire';
import { SsoreturnComponent } from './ssoreturn/ssoreturn.component';
import { SentryErrorHandler } from './core/sentry.error-handler';
import { ListLayersComponent } from './wgis/components/list-layers/list-layers.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    SiteLayoutComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    RegisterComponent,
    ResetpasswordComponent,
    SearchComponent,
    FaqsComponent,
    HelpComponent,
    HomeComponent,
    AuthComponent,
    SavedExperienceComponent,
    SavedOstComponent,
    DownloadsComponent,
    MapsComponent,
    Error404Component,
    WgisMapComponent,
    ProfileComponent,
    AppLayoutComponent,
    NotificationsComponent,
    AppHeaderComponent,
    ConfirmModalComponent,
    ConfirmFormModalComponent,
    ImageModalComponent,
    ProfileComponent,
    ResetpasswordComponent,
    SettingsComponent,
    UserComponent,
    ContactComponent,
    DisclaimerComponent,
    CreditComponent,
    AppstoreComponent,
    PrivacyComponent,
    ActivateUserComponent,
    TermsComponent,
    SsoreturnComponent,
    ListLayersComponent,
  ],
  imports: [
    AngularFireAuthModule,
    AngularFireModule.initializeApp(fireEnvironment.firebaseConfig),
    AngularFireMessagingModule,
    SuiModule,
    BrowserModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    Angulartics2Module.forRoot(),
  ],
  providers: [
    httpInterceptorProviders,
    AuthService,
    WMAIApiService,
    ApiService,
    WgisService,
    S3Service,
    { provide: ErrorHandler, useClass: SentryErrorHandler },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
